export const normalizeLeadingSlash = (str: string) => {
    return str.replace(/^(?!\/)/, '/');
};
